import actions from "@/store/parameter/actions";

export default [
  {
    path: "/transaction/deposit/list",
    name: "deposit",
    component: () => import("@/views/transaction/deposit/DepositList.vue"),
    meta: {
          pageTitle: "Deposit List",
          action: "view",
          resource: "deposit",
          breadcrumb: [
            { text: `Transaction`, active: true },
            {
              text: "Deposit",
              active: true
            }
          ]
        }
  },
  {
    path: "/transaction/withdrawal/list",
    name: "withdrawal",
    component: () => import("@/views/transaction/withdrawal/WithdrawalList.vue"),
        meta: {
          pageTitle: "Withdrawal List",
          action: "view",
          resource: "withdrawal",
          breadcrumb: [
            { text: `Transaction`, active: true },
            {
              text: "Withdrawal",
              active: true
            }
          ]
        }
  },
  // {
  //   path: "/transaction/withdrawalpending",
  //   name: "withdrawalPending",
  //   component: () => import("@/views/transaction/withdrawalPending/WithdrawalPending.vue"),
  //   redirect: { name: "withdrawalpending-list" },
  //   children: [
  //     {
  //       path: "/transaction/withdrawalpending/list",
  //       name: "withdrawalpending-list",
  //       component: () => import("@/views/transaction/withdrawalPending/WithdrawalPendingList.vue"),
  //       meta: {
  //         pageTitle: "Withdrawal Pending List",
  //         breadcrumb: [
  //           { text: `Transaction`, active: true },
  //           {
  //             text: "Withdrawal Pending",
  //             active: true
  //           }
  //         ]
  //       }
  //     },
  //   ]
  // },
{
        path: `/transaction/paymentaccount/list`,
        name: `payment-account`,
        component: () => import("@/views/transaction/paymentAccount/PaymentAccountList.vue"),
        meta: {
          pageTitle: "Payment Account List",
          action: "view",
          resource: "payment-account",
          breadcrumb: [
            { text: `Administration`, active: true },
            {
              text: "Payment Account",
              active: true
            }
          ]
        }
      },
      {
        path: `/transaction/paymentaccount/mutation/:accountNo`,
        name: `payment-account-mutation`,
        component: () => import("@/views/transaction/paymentAccount/PaymentAccountMutation.vue"),
        meta: {
          pageTitle: "Payment Account Mutation",
          action: ["view-mutation"],
          resource: "payment-account",
          breadcrumb: [
            { text: `Administration`, active: true },
            { text: "Payment Account", to: { name: `payment-account` } },
            { text: "Mutation", active: true }
          ]
        },
        props: true
      },
      {
        path: `/transaction/paymentaccount/adjustmentmutation/:accountNo`,
        name: `payment-account-adjustment-mutation`,
        component: () => import("@/views/transaction/paymentAccount/PaymentAccountAdjustmentMutation.vue"),
        meta: {
          pageTitle: "Payment Account Adjustment Mutation",
          action: "view-adjustment-mutation",
          resource: "payment-account",
          breadcrumb: [
            { text: `Administration`, active: true },
            { text: "Payment Account", to: { name: `payment-account` } },
            { text: "Adjustment Mutation", active: true }
          ]
        },
        props: true
      }
];
